module.exports = __webpack_public_path__ + "img/rating.c59bb9ef.png";